import { Component, inject, Injector, input, runInInjectionContext } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { firstValueFrom, map } from 'rxjs';

import { filterDefined } from '@core/common-legacy';
import { PositionDetailsDialogComponent } from '@core/tellent-positions-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';
import { DialogWidth } from '@core/user-interface-legacy';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

@Component({
  selector: 'x-position-details-dialog',
  template: ``,
  imports: [],
})
export class TellentPositionDetailsDialogWrapComponent extends DialogWrapComponent<PositionDetailsDialogComponent> {
  private readonly injector = inject(Injector);

  public readonly component = PositionDetailsDialogComponent;
  public readonly config = { width: DialogWidth.Medium };

  public positionGuid = input<string>();

  public resolveDialogData() {
    return runInInjectionContext(this.injector, () => {
      const positionGuid$ = toObservable(this.positionGuid).pipe(
        filterDefined,
        map(positionGuid => ({ positionGuid })),
      );
      return firstValueFrom(positionGuid$);
    });
  }
}

export type TellentPositionDetailsDialogWebComponent = TellentWebComponent<
  TellentPositionDetailsDialogWrapComponent,
  'open' | 'positionGuid' | 'afterClosed'
>;
